var _path, _path2;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgStripefees = function SvgStripefees(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4,0.8h16c1.8,0,3.2,1.4,3.2,3.2v16c0,1.8-1.4,3.2-3.2,3.2H4c-1.8,0-3.2-1.4-3.2-3.2V4C0.8,2.2,2.2,0.8,4,0.8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M11,9.2c0-0.6,0.5-0.8,1.3-0.8c1.4,0,2.7,0.4,3.9,1V5.7C15,5.2,13.7,5,12.3,5C9.1,5,7,6.6,7,9.3 c0,4.3,6,3.6,6,5.4c0,0.7-0.6,0.9-1.5,0.9c-1.3,0-3-0.5-4.3-1.2v3.7C8.5,18.7,10,19,11.5,19c3.3,0,5.5-1.6,5.5-4.3 C17,10.1,11,10.9,11,9.2L11,9.2z"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgStripefees, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/stripefees.16dc1955.svg";
export { ForwardRef as ReactComponent };